import { InjectionToken } from '@angular/core';
import { IOption } from '@shared/models/icommons.model';

export interface FilterOptionConfig {
  getFilterOptionsMenu: (params?: { isReports: boolean; filter: IOption }) => FilterOptionMenu[];
}

export interface FilterOptionMenu {
  labelKey: string;
  value: string;
  cssClass: string;
}

export const DEFAULT_OPT: FilterOptionMenu = Object.freeze({
  labelKey: 'recordsSearch.default',
  value: 'default',
  cssClass: 'default',
});

export const INCLUDE_EMPTY: FilterOptionMenu = Object.freeze({
  labelKey: 'recordsSearch.includeEmpty',
  value: 'includeEmpty',
  cssClass: null,
});

export const EXCLUDE_EMPTY: FilterOptionMenu = Object.freeze({
  labelKey: 'recordsSearch.populated',
  value: 'excludeEmpty',
  cssClass: null,
});

export const EXCLUDE_SELECTION: FilterOptionMenu = Object.freeze({
  labelKey: 'recordsSearch.exclude',
  value: 'excludeSelection',
  cssClass: null,
});

export const DefaultFilterOptionConfigFactory = () =>
  Object.freeze({
    getFilterOptionsMenu: () => [{ ...DEFAULT_OPT }, { ...INCLUDE_EMPTY }, { ...EXCLUDE_EMPTY }],
  });

export const FILTER_OPTIONS_CONFIG_TOKEN = new InjectionToken<FilterOptionConfig>('FILTER_OPTIONS_CONFIG_TOKEN');
